import React, { useState, useEffect } from 'react';
// import { base44 } from '@/api/base44Client';
import { Link } from 'react-router-dom';
import Icon from '../components/ui/Icon';
import StatsCard from '../components/dashboard/StatsCard';
import RecentActivity from '../components/dashboard/RecentActivity';
import ListingCard from '../components/listings/ListingCard';
import TransactionCard from '../components/transactions/TransactionCard';

export default function Dashboard() {
  const [listings, setListings] = useState([]);
  const [agents, setAgents] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const loadData = async () => {
  //     const [listingsData, agentsData, transactionsData] = await Promise.all([
  //       base44.entities.Listing.list('-created_date', 100),
  //       base44.entities.Agent.list('-created_date', 100),
  //       base44.entities.Transaction.list('-created_date', 100)
  //     ]);
  //     setListings(listingsData);
  //     setAgents(agentsData);
  //     setTransactions(transactionsData);
  //     setLoading(false);
  //   };
  //   loadData();
  // }, []);

  // This use effect is a placeholder to simulate data loading and API functionality.
  useEffect(() => {
  // Ignore API fetching for now
  setLoading(false);
}, []);


  const activeListings = listings.filter(l => l.status === 'active');
  const activeAgents = agents.filter(a => a.status === 'active');
  const pendingAgents = agents.filter(a => a.status === 'pending');
  const closedTransactions = transactions.filter(t => t.status === 'closed');

  const totalVolume = closedTransactions.reduce((sum, t) => sum + (t.final_price || 0), 0);
  const totalCommission = closedTransactions.reduce((sum, t) => sum + (t.commission_amount || 0), 0);

  const recentActivities = [
    ...listings.slice(0, 3).map(l => ({
      type: 'listing',
      title: `New listing: ${l.title}`,
      date: l.created_date,
      status: l.status
    })),
    ...agents.slice(0, 2).map(a => ({
      type: 'agent',
      title: `Agent ${a.status === 'pending' ? 'application' : 'joined'}: ${a.full_name}`,
      date: a.created_date,
      status: a.status
    })),
    ...transactions.slice(0, 2).map(t => ({
      type: 'transaction',
      title: `Transaction: ${t.buyer_name}`,
      date: t.created_date,
      status: t.status === 'closed' ? 'sold' : t.status
    }))
  ].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--slate-50)', padding: '2rem' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto' }}>
          <div className="skeleton" style={{ height: '2rem', width: '12rem', marginBottom: '2rem' }} />
          <div className="grid grid-4 gap-4 mb-8">
            {[1, 2, 3, 4].map(i => <div key={i} className="skeleton" style={{ height: '8rem' }} />)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--slate-50)', padding: '2rem' }}>
      <div style={{ maxWidth: '80rem', margin: '0 auto' }}>
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
          <div>
            <h1 className="text-3xl font-bold text-slate-900">Dashboard</h1>
            <p className="text-slate-500 mt-1">Welcome back! Here's your brokerage overview.</p>
          </div>
          <div className="flex gap-3">
            <Link to="/agents" style={{ textDecoration: 'none' }}>
              <button className="btn btn-outline">
                <Icon name="users" size={16} />
                Onboard Agent
              </button>
            </Link>
            <Link to="/listings" style={{ textDecoration: 'none' }}>
              <button className="btn btn-primary">
                <Icon name="plus" size={16} />
                New Listing
              </button>
            </Link>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-4 gap-4 mb-8">
          <StatsCard title="Active Listings" value={activeListings.length} subtitle={`${listings.length} total`} icon="home" />
          <StatsCard title="Active Agents" value={activeAgents.length} subtitle={pendingAgents.length > 0 ? `${pendingAgents.length} pending` : 'All approved'} icon="users" />
          <StatsCard title="Total Volume" value={`$${(totalVolume / 1000000).toFixed(1)}M`} subtitle={`${closedTransactions.length} closed`} icon="trendingUp" />
          <StatsCard title="Commissions" value={`$${totalCommission.toLocaleString()}`} subtitle="Total earned" icon="dollarSign" />
        </div>

        {/* Main Content */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {/* Recent Listings */}
            <div>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-slate-900">Recent Listings</h2>
                <Link to="/listings"className="text-sm text-slate-500" style={{ textDecoration: 'none' }}>
                  View all →
                </Link>
              </div>
              {listings.length > 0 ? (
                <div className="grid grid-2 gap-4">
                  {listings.slice(0, 4).map(listing => (
                    <ListingCard key={listing.id} listing={listing} />
                  ))}
                </div>
              ) : (
                <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
                  <Icon name="home" size={40} style={{ color: 'var(--slate-300)', margin: '0 auto 0.75rem' }} />
                  <p className="text-slate-500">No listings yet</p>
                  <Link to="/listings"style={{ textDecoration: 'none' }}>
                    <button className="btn btn-outline mt-3">Add First Listing</button>
                  </Link>
                </div>
              )}
            </div>

            {/* Active Transactions */}
            <div>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-slate-900">Active Transactions</h2>
                <Link to="/transactions" className="text-sm text-slate-500" style={{ textDecoration: 'none' }}>
                  View all →
                </Link>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {transactions.filter(t => t.status !== 'closed' && t.status !== 'cancelled').slice(0, 3).map(transaction => (
                  <TransactionCard
                    key={transaction.id}
                    transaction={transaction}
                    listing={listings.find(l => l.id === transaction.listing_id)}
                    agent={agents.find(a => a.id === transaction.agent_id)}
                  />
                ))}
                {transactions.filter(t => t.status !== 'closed' && t.status !== 'cancelled').length === 0 && (
                  <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
                    <Icon name="fileText" size={40} style={{ color: 'var(--slate-300)', margin: '0 auto 0.75rem' }} />
                    <p className="text-slate-500">No active transactions</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <RecentActivity activities={recentActivities} />

            {/* Pending Agents */}
            {pendingAgents.length > 0 && (
              <div style={{ background: '#fef3c7', borderRadius: '0.75rem', padding: '1.25rem', border: '1px solid #fcd34d' }}>
                <h3 className="font-semibold mb-3" style={{ color: '#92400e' }}>
                  Pending Approvals ({pendingAgents.length})
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  {pendingAgents.slice(0, 3).map(agent => (
                    <div key={agent.id} className="flex items-center gap-3" style={{ background: 'white', borderRadius: '0.5rem', padding: '0.75rem' }}>
                      <img
                        src={agent.photo_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(agent.full_name)}&size=40`}
                        style={{ width: '2.5rem', height: '2.5rem', borderRadius: '50%', objectFit: 'cover' }}
                        alt=""
                      />
                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-slate-900 truncate">{agent.full_name}</p>
                        <p className="text-xs text-slate-500">{agent.email}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <Link to="/agents" style={{ textDecoration: 'none' }}>
                  <button className="btn btn-outline w-full mt-3" style={{ fontSize: '0.875rem' }}>
                    Review All
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}